import React from "react";
import { usePlatformBranding } from "../contexts/PlatformBrandingContext";

// "Powered by ServiceGuru Pro" branded line — hyperlink controlled by the
// Platform Console. Used on estimate/invoice drawers and public pay/accept pages.
// `dark` styles it for the dark navy public pages.
export const PoweredBy = ({ dark = false, className = "" }) => {
  const { branding } = usePlatformBranding();
  const label = branding?.poweredByLabel || "Powered by ServiceGuru Pro";
  const url = branding?.poweredByUrl || "https://servicegurupro.com";
  return (
    <div className={`text-center text-[11px] ${className}`} data-testid="powered-by">
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="powered-by-link"
        className={`font-semibold transition-colors ${dark ? "text-slate-300 hover:text-white" : "text-indigo-600 hover:text-indigo-700"}`}
      >
        {label}
      </a>
    </div>
  );
};

export default PoweredBy;
